/**
 * @file: useGenderPicker.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { Gender } from '@euler/model/enum';
import { usePersistFn } from '@euler/utils/hooks';
import { useActionSheet } from '@expo/react-native-action-sheet';

export const useGenderPicker = (onChange: (gender: Gender) => any) => {
  const { showActionSheetWithOptions } = useActionSheet();
  return usePersistFn(() => {
    showActionSheetWithOptions(
      {
        title: '设置您的性别',
        options: ['男', '女', '取消'],
        cancelButtonIndex: 2,
      },
      async buttonIndex => {
        if (buttonIndex === 2 || buttonIndex == null) return;
        const gender = buttonIndex === 0 ? Gender.Male : Gender.Female;
        onChange(gender);
      },
    );
  });
};
